import { render, staticRenderFns } from "./SysSupplier.vue?vue&type=template&id=640b7315&scoped=true"
import script from "./SysSupplier.vue?vue&type=script&lang=js"
export * from "./SysSupplier.vue?vue&type=script&lang=js"
import style0 from "./SysSupplier.vue?vue&type=style&index=0&id=640b7315&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b7315",
  null
  
)

export default component.exports